import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import type { BasketMessageClickAndCollectViewModel } from 'autogen/swagger/all';
import { DisclaimerLink } from 'autogen/translation-keys/trans-website-basket-deliveryfix';
import InlineButton from 'components/generic/InlineButton';
import { Typography } from 'components/generic/typography';
import { useQuickView } from 'components/quickView';
import format from 'helpers/translations';
import { GA4Tracking } from 'modules/tracking/GA4/GA4Tracking';
import BasketMessageContainer from '../shared/styles';

const StyledBasketMessageContainer = styled(BasketMessageContainer)<{
    $type: BasketMessageClickAndCollectViewModel['type'];
}>`
    background-color: ${({ $type, theme }) => ($type === 'Achievement' ? theme.ColorBackgroundSuccessLight : theme.ColorBackgroundWarningLight)};
`;

const StyledInlineButton = styled(InlineButton)`
    margin-left: ${({ theme }) => theme.Spacing4};
`;

export default function ClickAndCollectMessage({
    model: { text, type, showDisclaimer }
}: {
    model: BasketMessageClickAndCollectViewModel;
}) {
    const { toggle } = useQuickView('antiBreakQuickView');
    const { t } = useTranslation();

    function handleClick() {
        toggle(true);
        GA4Tracking({
            eventName: 'open_modal',
            context: 'basket',
            category: 'ecommerce',
            eventParams: [
                {
                    param_name: 'modal_type',
                    param_value: 'anti_break'
                },
                {
                    param_name: 'trigger_origin',
                    param_value: 'basket_message'
                }
            ]
        });
    }

    return (
        <StyledBasketMessageContainer $type={type}>
            <Typography.Body as="span" size="S">
                {format(text)}
                {type === 'Information' && showDisclaimer && (
                    <StyledInlineButton onClick={handleClick}>{t(DisclaimerLink)}</StyledInlineButton>
                )}
            </Typography.Body>
        </StyledBasketMessageContainer>
    );
}
